import React, { Component } from "react";
import axios from "axios";
import styled from "styled-components";
import { withRouter } from "react-router-dom";

import PageTitle from "../../../commons/components/PageTitle";
import { ROUTES } from "../../../commons/constants/routes/routes";

class InquiryDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: null,
      answer: "",
      isSubmitting: false,
    };
    this.handleAnswerSubmit = this.handleAnswerSubmit.bind(this);
  }

  componentDidMount() {
    const id = window.location.pathname.split("/").pop();
    this.getItem(id);
  }

  async getItem(id) {
    try {
      const res = await axios.get(`/cst/api/inquiry/${id}`);
      const item = res.data;
      this.setState({ item, answer: item.answer || "" });
    } catch (e) {
      console.log(e);
    }
  }

  async handleAnswerSubmit(e) {
    e.preventDefault();
    const { item, answer } = this.state;
    if (!answer.trim()) return;

    this.setState({ isSubmitting: true });
    try {
      await axios.patch("/cst/api/inquiry/answer", {
        id: item.id,
        userId: item.userId,
        answer,
      });
      this.props.history.push(ROUTES.CS_INQUIRY.MAIN);
    } catch (err) {
      console.log(err);
    } finally {
      this.setState({ isSubmitting: false });
    }
  }

  render() {
    const { item, answer, isSubmitting } = this.state;
    if (!item) return null;

    return (
      <>
        <PageTitle title="문의 관리" location="문의 상세" />
        <FormWrapper>
          <FormContainer>
            <FormBox>
              <FormHead>제목</FormHead>
              <FormBody><ValueText>{item.title}</ValueText></FormBody>
            </FormBox>
            <FormBox>
              <FormHead>문의자</FormHead>
              <FormBody><ValueText>{item.userName}</ValueText></FormBody>
            </FormBox>
            <FormBox>
              <FormHead>연락처</FormHead>
              <FormBody><ValueText>{item.phone}</ValueText></FormBody>
            </FormBox>
            <FormBox>
              <FormHead>이메일</FormHead>
              <FormBody><ValueText>{item.email}</ValueText></FormBody>
            </FormBox>
            <FormBox>
              <FormHead>소속</FormHead>
              <FormBody><ValueText>{item.constructorName || "-"}</ValueText></FormBody>
            </FormBox>
            <FormBox>
              <FormHead>등록일</FormHead>
              <FormBody><ValueText>{item.inquiryDt}</ValueText></FormBody>
            </FormBox>
            <FormBox className="content-box">
              <FormHead>문의 내용</FormHead>
              <FormBody>
                <ContentArea>{item.content}</ContentArea>
              </FormBody>
            </FormBox>
          </FormContainer>

          <SectionTitle>답변</SectionTitle>

          <FormContainer>
            {item.approveState ? (
              <>
                <FormBox>
                  <FormHead>답변일</FormHead>
                  <FormBody><ValueText>{item.answerDt}</ValueText></FormBody>
                </FormBox>
                <FormBox className="content-box">
                  <FormHead>답변 내용</FormHead>
                  <FormBody>
                    <ContentArea>{item.answer}</ContentArea>
                  </FormBody>
                </FormBox>
              </>
            ) : (
              <FormBox className="content-box">
                <FormHead>답변 내용</FormHead>
                <FormBody>
                  <form onSubmit={this.handleAnswerSubmit}>
                    <AnswerTextarea
                      placeholder="답변 내용을 입력하세요"
                      value={answer}
                      onChange={(e) => this.setState({ answer: e.target.value })}
                      rows={6}
                    />
                    <AnswerBtnRow>
                      <button
                        type="button"
                        onClick={() => this.props.history.push(ROUTES.CS_INQUIRY.MAIN)}
                      >
                        목록
                      </button>
                      <button type="submit" className="primary" disabled={isSubmitting}>
                        답변 등록
                      </button>
                    </AnswerBtnRow>
                  </form>
                </FormBody>
              </FormBox>
            )}
          </FormContainer>

          {item.approveState && (
            <ActionRow>
              <button
                type="button"
                onClick={() => this.props.history.push(ROUTES.CS_INQUIRY.MAIN)}
              >
                목록
              </button>
            </ActionRow>
          )}
        </FormWrapper>
      </>
    );
  }
}

const FormWrapper = styled.div`
  width: 1176px;
  margin: 55px auto 120px;
`;
const FormContainer = styled.div`
  max-width: 1176px;
  width: 100%;
  margin: 0 auto 20px;
  border: 1px solid #4b515b;
  border-width: 1px 0 1px;
`;
const FormBox = styled.div`
  padding: 24px 0;
  border-bottom: 1px solid #e3e5e7;
  display: flex;
  align-items: flex-start;
  &.content-box {
    align-items: flex-start;
  }
`;
const FormHead = styled.p`
  width: 140px;
  flex-shrink: 0;
  font-size: 16px;
  color: #191919;
  font-weight: 600;
  padding-left: 12px;
`;
const FormBody = styled.div`
  flex: 1;
`;
const ValueText = styled.span`
  font-size: 15px;
  color: #191919;
`;
const ContentArea = styled.pre`
  font-size: 15px;
  color: #191919;
  white-space: pre-wrap;
  word-break: break-all;
  margin: 0;
  font-family: inherit;
  line-height: 1.6;
`;
const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #191919;
  margin: 40px 0 20px;
  padding-left: 4px;
  border-left: 4px solid var(--secondary-500);
`;
const AnswerTextarea = styled.textarea`
  width: 100%;
  max-width: 700px;
  padding: 12px;
  border: 1px solid #d5d8de;
  border-radius: 4px;
  font-size: 15px;
  line-height: 1.6;
  resize: vertical;
  font-family: inherit;
  &:focus {
    outline: none;
    border-color: var(--secondary-500);
  }
`;
const AnswerBtnRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
  button {
    width: 120px;
    font-size: 14px;
    padding: 10px 0;
    text-align: center;
    border-radius: 5px;
    font-weight: 600;
    cursor: pointer;
    &:first-child {
      color: var(--secondary-500);
      background-color: transparent;
      border: 1px solid var(--secondary-500);
    }
    &.primary {
      color: var(--grey-900);
      background-color: var(--primary-500);
      border: 1px solid var(--primary-500);
      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
`;
const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  max-width: 1176px;
  margin: 0 auto;
  button {
    width: 120px;
    font-size: 14px;
    padding: 10px 0;
    text-align: center;
    border-radius: 5px;
    font-weight: 600;
    cursor: pointer;
    color: var(--secondary-500);
    background-color: transparent;
    border: 1px solid var(--secondary-500);
  }
`;

export default withRouter(InquiryDetail);
